/**
 * Smoothly bring an element into view inside its nearest horizontal scroller.
 * First/last positions use exact scrollLeft bounds — `scrollIntoView({ nearest })`
 * can stop short and leave the edge item clipped.
 */

export type HorizontalScrollEdge = 'start' | 'end' | 'nearest';

export function findHorizontalScroller(
  from: HTMLElement,
): HTMLElement | null {
  let scroller: HTMLElement | null = from.parentElement;
  while (scroller) {
    const { overflowX } = getComputedStyle(scroller);
    if (
      overflowX === 'auto' ||
      overflowX === 'scroll' ||
      overflowX === 'overlay'
    ) {
      return scroller;
    }
    scroller = scroller.parentElement;
  }
  return null;
}

export function scrollElementIntoHorizontalView(
  element: HTMLElement,
  edge: HorizontalScrollEdge = 'nearest',
  behavior: ScrollBehavior = 'smooth',
): void {
  const scroller = findHorizontalScroller(element);
  if (!scroller) {
    element.scrollIntoView({ behavior, inline: 'nearest', block: 'nearest' });
    return;
  }

  if (edge === 'start') {
    scroller.scrollTo({ left: 0, behavior });
    return;
  }
  if (edge === 'end') {
    scroller.scrollTo({
      left: scroller.scrollWidth - scroller.clientWidth,
      behavior,
    });
    return;
  }

  element.scrollIntoView({ behavior, inline: 'nearest', block: 'nearest' });
}
